module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetHigh.435aa6a.jpg";